﻿import { IBaseContent } from './IBaseContent';
import { ITranslationContext, TranslationContext } from './TranslationContext';
// import { ITranslationContext, TranslationContext } from './TranslationContext';
import React from 'react';

export interface ITranslationManager {
  Get: (content: string | IBaseContent) => string;
  GetWithParams: (content: string, ...params: string[]) => string;
}

export const useTranslations = () => {
  // const tm = {
  //     Get: (s: string) => "*" + s,
  //     GetWithParams: (s: string, ...params: string[]) => "*" + s
  // } as ITranslationManager;

  // return tm;
  const tmContext = React.useContext(TranslationContext) as ITranslationContext;
  const tm = tmContext.TM;
  return tm;
}

// export function useTranslations(): ITranslationManager {
//   // const tmContext = React.useContext(TranslationContext) as ITranslationContext;
//   // const tm = tmContext.TM;

//   const tm = {
//     Get: (s: string) => "*" + s,
//     GetWithParams: (s: string, ...params: string[]) => "*" + s
//   } as ITranslationManager;


//   return tm;
// }
